module.exports = __webpack_public_path__ + "static/media/tofy-mash.f2e5b193.png";